import { Document, Page } from '@react-pdf/renderer';
import { useEffect } from 'react';
import { useStore } from '../../../app/stores/store';
import Html from 'react-pdf-html';
import ReactDOMServer from 'react-dom/server';
import { CheckboxHandler } from './ColorGrading';
import { metadataType } from '../../../app/api/types';
import { observer } from 'mobx-react-lite';
import { BaseGrade_DM_metadata, DmFramesReel, label } from './DM_And_Basegrading-constant';
import { getImageSrc } from '../../../utils/ImageHelper';
 const  DM_And_BaseGrading_Reports = ({name,isDualPDF}:{name:string,isDualPDF:boolean}) => {
    const {
        viewStore: { metadata, parentMetadata },
        activityStore: { selectedActivity },
        masteringStore
      } = useStore();
  // const [localMetaData, setLocalMetaData] = useState<any[]>([]);
  // const [dynData, setDynData] = useState<any>({});
  // const [bitDepth,setBitDepth] = useState<{
  //             imgSrc: string;
  //             label: string;
  //         }[]>([]);
  // const [Frames,setFrames] = useState<{total:number,actual:number}>({total:0,actual:0})
;    useEffect(() => {
        if (selectedActivity?.id) {
          parentMetadata({ itemId: selectedActivity?.id });
        }
        // eslint-disable-next-line
      }, []);
      useEffect(() => {
        if (metadata.length > 0) {
          const bitDepthIndex = metadata.findIndex((m: metadataType) => m.elementName === 'Bit Depth');
          const InputFormatMediumIndex = metadata.findIndex((m: metadataType) => m.elementName === 'Input Format/Medium')
              if(bitDepthIndex === -1 || InputFormatMediumIndex === -1) return;
                const InputFormatMediumValue = metadata[InputFormatMediumIndex].elementValue?.split(/[,|]/);
                 const splitedValue = metadata[bitDepthIndex].elementValue?.split(/[,|]/);
                const localArray = [];
                const generateLabel = (inputValue:any, bitDepthValue:any) => `${inputValue} DPX_${bitDepthValue}BIT`;
                const inputLength = InputFormatMediumValue.length;
                const bitDepthLength = splitedValue.length;
                if (inputLength === 1 && bitDepthLength === 1) {
                  localArray.push({
                    imgSrc: '../assets/NFAI_Restoration_Checkbox_Checked.png',
                    label: generateLabel(InputFormatMediumValue[0], splitedValue[0]),
                  });
                } else {
                  InputFormatMediumValue.forEach(inputValue => {
                    splitedValue.forEach(bitDepthValue => {
                      localArray.push({
                        imgSrc: '../assets/NFAI_Restoration_Checkbox_Checked.png',
                        label: generateLabel(inputValue, bitDepthValue),
                      });
                    });
                  });
                }
                masteringStore.DmAndBaseGradeList.bitDepth = localArray;
      }
      
        const tempTableData: any[] = []
        // eslint-disable-next-line
        metadata?.flatMap((m: metadataType) => {
            if (BaseGrade_DM_metadata.includes(m.elementName)) {
                tempTableData[BaseGrade_DM_metadata.indexOf(m.elementName)] = m;
              }
              if (m.elementType === 'DynamicTable' && m.elementName === name) {
                getDynamicTableData(m.elementValue);
              }
                           
        });

        masteringStore.DmAndBaseGradeList.localMetaData = tempTableData;
        // eslint-disable-next-line
       },[metadata]);
      const getDynamicTableData = (eleVal: string) => {
        const temp: any = {};
        temp['headers'] = [];
        let columnHeaders: string[] = [];
        let tempValue = [];
        if (eleVal?.includes('DynamicTable|')) {
          let stringData = eleVal?.split('DynamicTable|')?.[1]?.replaceAll(/\n/g,'');
          stringData = stringData?.split('_')?.join(' ');
          tempValue = stringData !== undefined ? JSON.parse(stringData) : [];
          if(name === 'DM Report'){
            tempValue =  tempValue.map((item:any) => {
              return {
                  ...item,
                  "Approve/ Not Approve": item['Approved (Yes / No)'] === 'Yes' ? 'Approve' : 'Not Approve'
              };
          }).map((item:any) => {
            const order = ['Reel No', 'Total Frames','Start Frame', 'End Frame', 'Actual Frames', 'Size', 'Approve/ Not Approve', 'Remarks', 'Approved By (Employee Id)', 'Path'];
              return order.reduce((acc:any, key:any) => {
                  acc[key] = item[key]?.toString() || ''; // Setting empty string for non-existing keys
                  return acc;
              }, {});
          });
          }
          if(name === 'Grading Report'){
            tempValue = tempValue.map((item:any) => {
              const { "DM Path": __, ...rest } = item;
              return rest;
            }).map((item:any) => {
              const order = ['Reel No', 'Total Frames','Start Frame', 'End Frame', 'Actual Frames', 'Data Size', 'Grade Type', 'Noticeable Remarks in Color Reproduction',];
                return order.reduce((acc:any, key:any) => {
                    acc[key] = item[key]?.toString() || ''; // Setting empty string for non-existing keys
                    return acc;
                }, {});
            });
          }
          tempValue = tempValue?.map((element: { "Reel No": string }) => ({ ...element, "Reel No": element["Reel No"].replace(/\s/g, '_') }));
          columnHeaders = Object.keys(tempValue[0] || []);  
          columnHeaders = columnHeaders?.filter((data) => data !== ' uuid ');
        }
        temp['headers'] = columnHeaders;
        temp['body'] = tempValue;
        if(name === 'Grading Report'){
          const sumFrames = (key: keyof DmFramesReel, body: DmFramesReel[]): number => 
            body.reduce((total, obj) => 
              total + obj[key].split("\t").map(Number).reduce((acc, cur) => acc + cur, 0)
            , 0);
          
          const totalFrames = sumFrames("Total Frames", temp.body);
          const actualFrames = sumFrames("Actual Frames", temp.body);
          masteringStore.DmAndBaseGradeList.frames = {total:totalFrames,actual:actualFrames}
        }
        masteringStore.DmAndBaseGradeList.dynData = temp;
      };

    

      const element = (
        <html>
          <body>
            <style>
              {`
              * {
                font-size: 7px;
              }
              #container {
                margin: 20px 10px;
              }
              #container table td:first-child {
                width: 33.33%;
              }
              #container table td:nth-child(n+2) {
                width: 66.66%;
              }
            #container tbody {
              column-count:2;
        -moz-column-count:2;
        -webkit-column-count:2;
            }
            .l-grey-bg {
              background-color: lightgray;
            }
            .grey-bg {
              background-color: gray;
            }
            .d-grey-bg {
              background-color: darkslategray;
            }
            .nfai-table {
              width: 90%;
              margin-left: auto;
              margin-right: auto;
            }
            .center-content {
              text-align: center;
            }
            .padding-4 {
              padding: 4px;
            }
            .padding-2 {
              padding: 2px;
            }
            .nfai-table,
            .nfai-table th,
            .nfai-table td {
              border: 1px solid black;
              border-collapse: collapse;
            }
            .nfai-table td {
              padding: 2px;
            }
            .nfai-table table,
            .nfai-table table th, .nfai-table table td {
              border: none;
              border-collapse: collapse;
            }
            .bold {
              font-weight: 700;
            }
            .border-top-0 {
              border-top: 0px;
            }
            .white-text {
              color: white;
            }
            .yellow-bg {
              background-color: #cb9d06;
            }
            .pd-left-4{
              padding-left: 100px;
            }
            .img{
              width:100px;
              height:40px;
            }
            .img .img-prasadlogo {
              width: 100%;
              height: 100%;
        }
        .column-width{
          max-width:100px!important;
        }
        .word-wrap{
          minWidth: 100px
        }
        .header-content{
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
        }
      td.font-size-15{
          font-size: 15px;
        }
            `}
            </style>
            <div id="container">
              <table className="nfai-table border-top-0">
                <tbody>
                  <tr>
                    <td className='column-width img'> <img src="../assets/PrasadCorp.jpg" alt="Prasad Corp Logo" className='img-prasadlogo'/></td>
                    <td className='l-grey-bg header-content font-size-15'>{name === 'DM Report' ? 'Data Management Report' : 'GRADING - QC REPORT'}</td>
                  </tr>
                  {(masteringStore.DmAndBaseGradeList.localMetaData || [])?.map(
                    (l: metadataType, ind: number) => {
                      return (
                        <tr key={l.elementIndex}>
                          <td className='column-width l-grey-bg'>
                            {label[l.elementName as keyof typeof label] !==
                            undefined
                              ? label[l.elementName as keyof typeof label].toUpperCase()
                              : l.elementName.toUpperCase()} : 
                          </td>
                          <td className="center-content">
                            {// eslint-disable-next-line
                            l.elementName === 'Film Gauge' ?  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginLeft: '2px' }}>
                              {/* l.elementValue.split('|').map(e =>) */}
                              {l.elementValue.includes('|') ? l.elementValue.split('|').map((item,index) => (
                                    <><img
                                            key={index}
                                            src={'../assets/NFAI_Restoration_Checkbox_Checked.png'}
                                            alt="Checkbox"
                                            style={{ width: '10px', height: '10px', margin: '0 5px' }}
                                          /> 
                                      <span>{item}</span>
                                    </>
                                  )) : l.elementValue }
                            </div> : l.elementName === 'Censor Certificate' ? l.elementValue :
                               l?.options?.length !== 0
                              ? CheckboxHandler(l.options, l.elementValue,'DM')
                              : l.elementName === 'Resolution' ? `${l.elementValue}_DPX`
                              : ['Input Format/Medium', 'Delivery Format/Medium'].includes(l.elementName) && !l.elementValue.includes('DPX') ? 
                              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginLeft: '2px' }}>
                                  {masteringStore.DmAndBaseGradeList.bitDepth.map((item,index) => (
                                    <>
                                    {masteringStore.DmAndBaseGradeList.bitDepth.length === 1 ? (
                                        <></>
                                      ) : masteringStore.DmAndBaseGradeList.bitDepth.length !== 0 ? (
                                          <img
                                            key={index}
                                            src={item.imgSrc}
                                            alt="Checkbox"
                                            style={{ width: '10px', height: '10px', margin: '0 5px' }}
                                          />
                                      ) : null}

                                      <span>{item.label}</span>
                                    </>
                                  ))}
                                </div>
                              : l.elementValue?.split('|')[1] || l.elementValue}
                          </td>
                        </tr>
                      );
                    },
                  )}
                </tbody>
              </table>
              <table className="nfai-table border-top-0 ">
                     <tr>
                <th className='padding-4 border-top-0 d-grey-bg'>
                </th>
 </tr>
              </table>
              <table className="nfai-table border-top-0 ">
            <thead className="border-top-0">
              <tr>
                {masteringStore.DmAndBaseGradeList.dynData['headers']?.map((headerName: string) => {
                  return (
                    <th
                      className="center-content padding-2 bold l-grey-bg"
                      style={headerName === 'Noticeable Remarks in Color Reproduction'
                        ? { maxWidth: '30%', flexWrap: 'wrap', }
                        : name === 'DM Report' && headerName === 'Path' ? { maxWidth: '26%', flexWrap: 'wrap',} 
                            : name === 'DM Report' ? { maxWidth: '9%', flexWrap: 'wrap',} 
                         : { maxWidth: '10%', flexWrap: 'wrap', }}
                      key={headerName}
                    >
                      {headerName}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {masteringStore.DmAndBaseGradeList.dynData['body']?.map(
                (bodyData: any) => {
                  return (
                    <tr >
                      {masteringStore.DmAndBaseGradeList.dynData['headers']?.map((headerName: string) => {
                        return (
                          <td
                          className={headerName === 'Noticeable Remarks in Color Reproduction' ? '' : 'center-content'}
                          // className={headerName === 'Noticeable Remarks in Color Reproduction' ? '' : ''}
                          style={headerName === 'Noticeable Remarks in Color Reproduction'
                            ? { maxWidth: '30%', flexWrap: 'wrap', }
                            : name === 'DM Report' && headerName === 'Path' ? { maxWidth: '26%', flexWrap: 'wrap',} 
                            : name === 'DM Report' ? { maxWidth: '9%', flexWrap: 'wrap',} 
                             : { maxWidth: '10%', flexWrap: 'wrap', }}
                          >
                            {typeof bodyData[headerName] === 'object'
                              ? JSON.stringify(bodyData[headerName])
                              : bodyData[headerName]?.replace(/,(?!\s)/g, ', ')}
                          </td>
                        );
                      })}
                     
                    </tr>
                  );
                },
              )}
              {
                name === 'Grading Report' 
                ? <tr >
                  <td className='center-content' style={{ maxWidth: '10%' }}>TOTAL</td>
                  <td className='center-content' style={{ maxWidth: '10%' }}>{masteringStore.DmAndBaseGradeList.frames.total}</td>
                  <td className='center-content' style={{ maxWidth: '10%' }}></td>
                  <td  style={{ maxWidth: '10%' }}></td>
                  <td  className='center-content' style={{ maxWidth: '10%' }}>{masteringStore.DmAndBaseGradeList.frames.actual}</td>
                  <td  style={{ maxWidth: '10%' }}></td>
                  <td  style={{ maxWidth: '10%' }}></td>
                  <td >Approved</td>
                </tr> : null
              }
            </tbody>
          </table>
          {isDualPDF ? 
              <div style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
            {/* eslint-disable-next-line */}
            <img 
              src={getImageSrc('bala')} 
              style={{ width: 65, height: 35, marginTop: 20 }} 
            />
          </div> : null}
            </div>
          </body>
        </html>
      );
       const html = ReactDOMServer.renderToStaticMarkup(element);
    return (
        <Document>
          <Page style={{ padding: '18px' }}>
            <Html>{html}</Html>
          </Page>
        </Document>
      );
}
export default observer(DM_And_BaseGrading_Reports);